import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import {
  Button,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap"

const UpdateJobPromotion = ({ isOpen, toggle, onChange }) => {
  const { t } = useTranslation()
  const [canPromote, setCanPromote] = useState(false)

  return (
    <Modal isOpen={isOpen} toggle={toggle} backdrop="static">
      <ModalHeader toggle={toggle}>{t("Can promote candidates")}</ModalHeader>
      <ModalBody>
        <FormGroup>
          {/* <Label for="jobTitle">{t("Can promote candidates")}</Label> */}
          <Input
            type="select"
            id="jobTitle"
            value={canPromote || ""}
            onChange={e => setCanPromote(e.target.value)}
          >
            <option value="" disabled>
              -- {t("Select preferrence")} --
            </option>
            {[
              { label: "Yes", value: true },
              { label: "No", value: false },
            ].map(job => (
              <option key={job.value.toString()} value={job.value}>
                {t(job.label)}
              </option>
            ))}
          </Input>
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          {t("Close")}
        </Button>
        <Button color="primary" onClick={() => onChange(canPromote)}>
          {t("Change")}
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default UpdateJobPromotion
